import React, { useContext, useEffect, useRef, useState } from "react";
import { Context } from "..";
import Button from "./Button";
import { Icon } from "@iconify/react";
import { ReactComponent as TeethSvg } from "../assets/svg/teeth.svg";
import { ReactComponent as OaSvg } from "../assets/svg/oa.svg";
import basketStore from "../store/basketStore";
import { observer } from "mobx-react-lite";
import {
  initialCookieOptions,
  notificationTimeouts,
  notificationTypes,
} from "../utils/consts";
import { useCookies } from "react-cookie";
import "../css/to-basket.css";
import userStore from "../store/userStore";
import basketApi from "../api/basketApi";
import { debounce, showStandartNotification } from "../utils/helpers";

function showMoreItemsThanAllowed() {
  showStandartNotification({
    text: "Вы не можете добавить больше 15 товаров в корзину",
    type: notificationTypes.reject,
    timeout: notificationTimeouts.short,
  });
}

const ToBasket = (props) => {
  const [basketItems, setBasketItems] = useState(basketStore.items);
  const [ourBasketItem, setOurBasketItem] = useState({}); // объект с amount с сервера
  const itemData = props.itemData || {}; // обычный объект товара
  const [inputValue, setInputValue] = useState(ourBasketItem.amount);
  const abortControllerRef = useRef(null);

  useEffect(() => {
    setInputValue(ourBasketItem.amount);
  }, [ourBasketItem.amount]);

  const createNewAbortController = () => {
    // Отменяем предыдущие запросы
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    // Создаем новый AbortController
    abortControllerRef.current = new AbortController();
    return abortControllerRef.current.signal;
  };

  async function handleAddToBasket() {
    const signal = createNewAbortController();
    try {
      await basketStore.addToBasket(itemData, signal);
      console.log("addToBasket: success");
    } catch (err) {
      showMoreItemsThanAllowed();
    }
  }

  async function handleRemoveFromBasket() {
    const signal = createNewAbortController();
    try {
      await basketStore.removeOneFromBasket(itemData.itemId, signal);
      console.log("removeFromBasket: success");
    } catch (err) {
      showMoreItemsThanAllowed();
    }
  }

  const debouncedSetToBasket = debounce(async (amount) => {
    const signal = createNewAbortController();

    try {
      await basketStore.setToBasket(itemData, amount, signal);
      console.log("setToBasket: success");
    } catch (err) {
      showMoreItemsThanAllowed();
    } finally {
      setInputValue(basketStore.items[itemData.itemId]?.amount);
    }
  }, 500);

  // При изменении в basketStore.items изменяем локальные переменные
  useEffect(() => {
    setBasketItems(basketStore.items);
    setOurBasketItem(basketStore.items[itemData.itemId] || {});
  }, [basketStore.items, itemData.itemId]);

  return (
    <>
      {itemData.teeth && (
        <div className="to-basket">
          {userStore.isAuth ? (
            <>
              {!ourBasketItem.amount && (
                <>
                  <Button
                    className="accent fullwidth rectangled gap-0-5"
                    onClick={() => handleAddToBasket()}
                  >
                    <Icon
                      icon="el:shopping-cart"
                      width="1.2rem"
                      height="1.2rem"
                    />{" "}
                    В корзину
                  </Button>
                </>
              )}
              {ourBasketItem.amount && (
                <div className="in-basket d-flex justify-around">
                  <Button
                    className="change substract accent rectangled"
                    onClick={() => handleRemoveFromBasket()}
                  >
                    -
                  </Button>
                  <input
                    type="number"
                    min={1}
                    value={inputValue}
                    onChange={(e) => {
                      debouncedSetToBasket(+e.target.value);
                      setInputValue(e.target.value);
                    }}
                    className="amount"
                  />
                  <Button
                    className="change add accent rectangled"
                    onClick={() => handleAddToBasket()}
                  >
                    +
                  </Button>
                </div>
              )}
            </>
          ) : (
            <p className="w-100">Войдите чтобы добавить в корзину</p>
          )}
          <div className="price d-flex justify-around">
            <span className="teeth">
              <TeethSvg /> {itemData.teeth}
            </span>
          </div>
        </div>
      )}
    </>
  );
};

export default observer(ToBasket);
